import { Reducer } from 'redux';
import { POTWState, POTWAction } from './types';

// Type-safe initialState!
export const initialState: POTWState = {
    url: null,
    description: null,
    width: 0,
    height: 0
};

// Unfortunately, typing of the `action` parameter seems to be broken at the moment.
// This should be fixed in Redux 4.x, but for now, just augment your types.

const reducer: Reducer<POTWState> = (state: POTWState = initialState, action) => {
    // We'll augment the action type on the switch case to make sure we have
    // all the cases handled.
    switch (action.type) {
        case '@@potw/LOAD':
            return action.payload;
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./store/potw/reducer.ts